import React from 'react';
import { Images, RolePermission, PermissionsList } from 'utils';
import {
  TextRow,
  DateRow,
  EditWithIcon,
} from 'components';
import moment from 'moment';

export const resourceHead = [
  // { name: 'name', searchKey: 'name', title: 'Folder Name', custom: false },
  { name: 'name', title: 'Folder Name', custom: false },
  { name: 'createdDate', title: 'Created Date', disabled: true, custom: false },
  { name: 'lastUpdated', title: 'Last Updated', disabled: true, custom: false },
  { name: 'shared', title: 'Shared With', disabled: true, custom: false, width: '15%' },
  RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
  { name: 'actions', title: 'Actions', disabled: true, custom: false, width: '100px' },
];

export const resourceBody = () => [
  {
    rowText: (item) => <TextRow name={item?.name} />,
  },
  {
    rowText: (item) => <div>
      <DateRow date={item?.createdAt} />
      <TextRow name={`${moment(item?.createdAt).format('hh:mm a')} by ${item?.createdByFullName}`}  />
    </div>,
  },
  {
    rowText: (item) => (item?.updatedAt && item?.updatedByFullName) ?
      <div>
        <DateRow date={item?.updatedAt} />
        <TextRow name={`${moment(item?.updatedAt).format('hh:mm a')} by ${item?.updatedByFullName}`} />
      </div>
      :
      'N/A',
  },
  {
    rowText: (item) => renderSharedWidth(item),
  },
  RolePermission([PermissionsList.MANAGE_RESOURCE?.code]) &&
  {
    button: (fn) => <div className='flex-align-center' style={{ gap: 16 }}>
      <EditWithIcon handleClick={() => fn('edit')} />
      <EditWithIcon handleClick={() => fn('delete')} icon={Images.trashNew} />
    </div>,
    notClickable: true,
  },
];

export const ACTION_TYPE = 'GET_RESOURCE';
export const GET_SINGLE_ACTION_TYPE = 'GET_RESOURCE_BY_ID';

const renderSharedWidth = (item) => {
  const sharedWith = item?.sharedWith || [];
  const total = sharedWith.length;


  if (total === 0) return 'N/A';

  const visibleUsers = sharedWith.slice(0, 5);
  const extraCount = total - 5;



  return (
    <div className='flex-align-center'>
      {visibleUsers.map((user, index) => (
        <div
          className='resource-avatar-box'
          key={index}
          style={{ marginLeft: index === 0 ? 0 : '-18px' }}
        >
          {user?.adminAvatar ? (
            <img src={user.adminAvatar} alt='avatar' />
          ) : (
            `${user?.adminFirstName?.[0] || ''}${user?.adminLastName?.[0] || ''}`
          )}

        </div>
      ))}

      {extraCount > 0 && (
        <div className='resource-avatar-box' style={{ marginLeft: '-18px', background:'#F7F9FC' }}>
          +{extraCount}
        </div>
      )}
    </div>
  );
};

